import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { getAllAssessmentAccounts } from "../../../connectors/unifiedBalanceApi";
import { useAppSelector } from "../../../store/hooks";
import { AssessmentAccount } from "../types/types";

export const useAllAccountsUnified = () => {
  const { user } = useAppSelector((state) => state.authentication);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email") || user?.email || "";

  const {
    data: assessmentAccounts,
    isLoading,
    isFetching,
  } = useQuery({
    enabled: false,
    queryFn: () => getAllAssessmentAccounts({ email }),
    queryKey: ["assessmentAccountsModal", email],
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  const allAccountsUnified =
    !!assessmentAccounts?.length &&
    assessmentAccounts?.every(
      (acc: AssessmentAccount) => !!acc.assessment.unification_status,
    );

  return { allAccountsUnified, assessmentAccounts, isLoading, isFetching };
};
